import { render, staticRenderFns } from "./change_password.vue?vue&type=template&id=156e9a8c&"
import script from "./change_password.vue?vue&type=script&lang=js&"
export * from "./change_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156e9a8c')) {
      api.createRecord('156e9a8c', component.options)
    } else {
      api.reload('156e9a8c', component.options)
    }
    module.hot.accept("./change_password.vue?vue&type=template&id=156e9a8c&", function () {
      api.rerender('156e9a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/change_password.vue"
export default component.exports